/*
 * Shared full-screen loading overlay (blur + spinning ring + rotating funny captions).
 * One implementation for the build finder and the product-page configurator.
 *
 * Markup:  snippets/gbg-loading-overlay.liquid   ([data-gbgb-loading-overlay])
 * Styles:  assets/gbg-loading.css
 *
 * GBGLoading.show(el?, portal?)  - shows the overlay; portal=true moves it to <body> so
 *                                  no transformed ancestor can break position:fixed.
 * GBGLoading.hide(el?)
 */
(function (root) {
  'use strict';

  var CAPTIONS = [
    'Dropping in the CPU',
    'Tightening all the screws',
    'Finding tiny M.2 screws',
    'Reading the manual',
    'Actually reading the manual',
    'Applying thermal paste',
    'Plugging in cables',
    'Decoding front panel pins',
    'Hiding the cable spaghetti',
    'Zip-tying zip ties'
  ];
  var timer = null;

  function pick(el) {
    return el || document.querySelector('[data-gbgb-loading-overlay]');
  }

  function lockScroll(on) {
    document.documentElement.classList.toggle('gbgb-scroll-locked', on);
    document.body.classList.toggle('gbgb-scroll-locked', on);
  }

  function show(el, portal) {
    el = pick(el);
    if (!el) return;
    if (portal && el.parentNode !== document.body) document.body.appendChild(el);
    el.hidden = false;
    lockScroll(true);
    var caption = el.querySelector('[data-gbgb-loading-caption]');
    clearInterval(timer);
    if (caption) {
      var i = Math.floor(Math.random() * CAPTIONS.length);
      caption.textContent = CAPTIONS[i];
      timer = setInterval(function () {
        i = (i + 1) % CAPTIONS.length;
        caption.textContent = CAPTIONS[i];
      }, 2000);
    }
  }

  function hide(el) {
    el = pick(el);
    clearInterval(timer);
    if (el) el.hidden = true;
    lockScroll(false);
  }

  // The overlay only belongs to an in-progress Add to Cart. When the browser restores this page
  // from its back/forward cache (Back from /cart), it comes back exactly as it was left -
  // overlay up. Clear every overlay and tell callers to reset their "busy" flags.
  function resetAll() {
    clearInterval(timer);
    document.querySelectorAll('[data-gbgb-loading-overlay]').forEach(function (el) { el.hidden = true; });
    lockScroll(false);
    root.dispatchEvent(new CustomEvent('gbg:loading-reset'));
  }
  root.addEventListener('pageshow', function (e) { if (e.persisted) resetAll(); });
  root.addEventListener('pagehide', function () {
    clearInterval(timer);
    document.querySelectorAll('[data-gbgb-loading-overlay]').forEach(function (el) { el.hidden = true; });
    lockScroll(false);
  });

  root.GBGLoading = { captions: CAPTIONS, show: show, hide: hide, reset: resetAll };
})(window);
